const HeaderComponent = {
    data() {
        return {
            isAuth: window.globalState.isAuth,
            cartTotal: 0,
            unsubscribeCallbacks: [],

            windowWidth: window.innerWidth,
            loadingSearch: false,
        };
    },

    computed: {
        sumCartTotal() {
            return this.cartTotal > 0
                ? window.globalState.formatPrice(this.cartTotal)
                : "Корзина";
        },

        placeholderText() {
            return this.windowWidth > 767
                ? 'Введите название запчасти, артикул или код товара'
                : 'Введите артикул или наименование';
        },
    },

    methods: {
        async logout() {
            await window.userHelpers.logout();
        },

        sendSearch() {

            this.loadingSearch = true;

            try {

                const form = document.getElementById("sendSearch");
                const searchInput = form.querySelector('input[name="search"]');
                const searchValue = searchInput ? searchInput.value.trim() : '';

                if ( searchValue === '' || searchValue.length < 3 ) {
                    globalState.addNotification(
                        `Минимальная длина запроса: 3 символа`
                    );
                    return;
                }

                const encodedSearch = encodeURIComponent(searchValue);

                window.location.href = `${window.appConfig.routes.searchPage}?search=${encodedSearch}`

            } catch (err) {
                console.error("Ошибка при поиске:", err);
            } finally {
                this.loadingSearch = false;
            }

        },

        handleResize() {
            this.windowWidth = window.innerWidth;
        },
    },

    mounted() {
        // ВАЖНО: Добавляем слушатель события resize
        window.addEventListener('resize', this.handleResize);

        this.handleResize();

        // auth
        const unsubAuth = window.globalState.onAuthChange(v => {
            this.isAuth = v;
        });

        // cart
        const unsubCart = window.globalState.onCartChange(cart => {
            this.cartTotal = cart.total;
        });

        this.unsubscribeCallbacks.push(unsubAuth, unsubCart);

        // инициируем загрузку (localStorage → сервер)
        window.globalState.loadCart();
    },

    beforeUnmount() {
        this.unsubscribeCallbacks.forEach(u => u && u());
        // Удаляем слушатель события resize
        window.removeEventListener('resize', this.handleResize);
    },

};

window.HeaderComponent = HeaderComponent;